import NavBarComponent from "../../NavBarComponent";
import {AppSection} from "../../../Consts";

const DocsPage = () => (
    <>
        <NavBarComponent sectionName={AppSection.Docs} />
        <section className="docs">
            <div className="text-center mb-8">
                <h2 className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                    Dokumentacja
                </h2>
                <p className="mt-4 text-xl text-gray-400">W trakcie budowy... Powiadomimy cię kiedy będzie dostępna.</p>
            </div>
        </section>
    </>


)

export default DocsPage